import {MenuItem, FormControl, OutlinedInput, styled, Select} from "@mui/material"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {COUNTRY_SELECTOR_DRAWER_BREAKPOINT} from "../../config/constants"

export const styles = {
    root: {
        "&&": {
            width: "100%",
            height: "2rem",
            display: "flex",
            justifyContent: "flex-start",
            padding: "0 1rem",
        },
    },
    icon: {
        minWidth: "2rem",
    },
}

export const StyledOutlinedInput = styled(OutlinedInput)`
    background: ${({theme}) => theme.uxfabric.action.default.enabled.backgroundColor};
    && {
        line-height: normal;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.select.large.borderRadius};
        text-transform: ${({theme}) => theme.uxfabric.component.inputText.textTransform};

        @media (min-width: ${breakpoints.values.md}px) {
            border-radius: ${({theme}) => theme.uxfabric.shape.global.select.medium.borderRadius};
            height: 2.25rem;
        }
    }
    &&& > fieldset {
        border: 0.0625rem solid ${({theme}) => theme.uxfabric.action.default.enabled.borderColor};
    }
`

export const SelectedFormControl = styled(FormControl)`
    &:hover {
        border: none;
    }
    width: 100%;
`

export const SelectedMenuItem = styled(MenuItem)`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding-right: 0.5rem;
    padding-left: 1rem;
    transition: color 0s, background-color 0s;
    text-transform: ${({theme}) => theme.uxfabric.component.menuItem.textTransform};
    font-size: ${({theme}) => theme.uxfabric.component.menuItem.fontSize};
    font-family: ${({theme}) => `${theme.uxfabric.component.menuItem.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-weight: ${({theme}) => theme.uxfabric.component.menuItem.fontWeight};

    &.Mui-selected {
        background-color: ${({theme}) => theme.uxfabric.components.menu.default.selected.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.menu.default.selected.textColor};
        &.Mui-focusVisible {
            background-color: ${({theme}) => theme.uxfabric.components.menu.default.selected.backgroundColor};
            color: ${({theme}) => theme.uxfabric.components.menu.default.selected.textColor};
        }
    }
    &.Mui-selected:hover {
        background-color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.textColor};
    }
    &:hover {
        background-color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.backgroundColor};
        color: ${({theme}) => theme.uxfabric.components.menu.default.hovered.textColor};
    }
`

export const StyledIcon = styled("img")`
    && {
        top: calc(50% - 0.25rem);
        right: 1rem;
    }
`

export const StyledSelect = styled(Select)`
    width: 100%;
    height: 2.75rem;
    @media (min-width: ${COUNTRY_SELECTOR_DRAWER_BREAKPOINT}) {
        width: 28rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        height: 2rem;
    }
    && > div {
        padding: 0 2.25rem 0 1rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;
    }
    && > div:focus {
        background-color: transparent;
    }
    &&.selectOpen {
        border-radius: 0.25rem 0.25rem 0 0;
    }
    && .selectBody {
        border-radius: 0 0 0.25rem 0.25rem;
    }
    && > div > .MuiMenu-paper {
        max-height: 18.75rem;
        width: 28rem;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.menu.default.borderRadius};
    }
`
